import BannerSetup from "@commons/banner-settings";
import React from "react";

const AdminBannerSetup = () => {
  return <BannerSetup />;
};

export default AdminBannerSetup;
